export function calcAmount(space) {
	if (!space.Rooms || !Array.isArray(space.Rooms)) return [];
	const perLiverAmount = space.PerLiverAmount
		? [...space.PerLiverAmount]
		: [];
	const perLiverGuard = space.PerLiverGuard || [];

	perLiverGuard.forEach((guard) => {
		const found = perLiverAmount.some(
			(item) => item.uid + "" === guard.liver_id + "",
		);
		if (!found) {
			const roomInfo = space.Rooms.find(
				(r) => r.LiverID + "" === guard.liver_id + "",
			);
			perLiverAmount.push({
				uid: guard.liver_id,
				u_name: guard.u_name,
				live_room:
					guard.live_room || guard.room || roomInfo?.LiveRoom || "",
				total: 0,
			});
		}
	});

	return perLiverAmount
		.map((item) => {
			var guardSum = 0;
			perLiverGuard.forEach((guard) => {
				if (guard.liver_id + "" === item.uid + "") {
					guardSum += [15998, 1598, 138][guard.type - 1];
				}
			});
			return {
				...item,
				guard: guardSum,
				Rate:
					(item.total + guardSum) /
					(space.GiftMoney + space.GuardMoney),
				CountNode:
					"￥" +
					(item.total + guardSum).toLocaleString(undefined, {
						minimumFractionDigits:
							item.total + guardSum > 998 ? 0 : 1,
						maximumFractionDigits:
							item.total + guardSum > 998 ? 0 : 1,
					}),
				LiveRoom: item.live_room,
				Count: item.total + guardSum,
				Liver: item.u_name,
				LiverID: item.uid,
			};
		})
		.sort((a, b) => b.Rate - a.Rate)
		.filter((item) => item.Count !== 0);
}
